import { couponsSlice } from './reducer';

export const { fetchCouponsGroup, receiveCouponsGroup, resetCouponsGroup } = couponsSlice.actions;
